import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import './registerServiceWorker'
import WJH from '@/js/wjhJS.js'
import './base.css'
import './style.css'
import VConsole from 'vconsole'
import {Table,TableColumn} from "element-ui"
Vue.prototype.WJH = WJH
Vue.config.productionTip = false
require('@/js/setSize')

Vue.use(Table)
Vue.use(TableColumn)

if(process.env.NODE_ENV === 'development'){
  new VConsole()
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
